import { EField, IExtraData } from "./schema.addCustomMessage.types";

export const getInitialValues = (extraData: IExtraData) => {
  return {
    [EField.CustomMessageBody]: extraData.customMessageBody,
  };
};
